import { Component } from '@angular/core';

@Component({
  selector: 'dp-loader',
  standalone: true,
  imports: [],
  templateUrl: './dp-loader.component.html',
  styleUrl: './dp-loader.component.scss'
})
export class DpLoaderComponent {

}
